<template>
  <div class="container">
    <form @submit.prevent="goNext">
      <HeadingOne class="-margin-md">ご本人さま確認書類のご提出</HeadingOne>

      <ErrorsAlert :errors="errors"></ErrorsAlert>

      <slot name="wizard"></slot>
      <section>
        <slot name="message"></slot>
        <p>アップロードする書類2点を以下より選択してください。</p>
        <TableGroup>
          <TableBox class="-entry">
            <TableBody>
              <TableRow>
                <TableHeader> ご本人さま確認書類（1点目） </TableHeader>
                <TableData>
                  <InputGroup>
                    <BtngroupRadio>
                      <BtnRadio
                        v-for="(identityType, index) in identityTypes"
                        :id="'identityType' + index"
                        :key="'identityType' + index"
                        v-model="identity"
                        name="identityRadio"
                        :class="{
                          disabled: isSelectedIdentity(identityType['value']),
                        }"
                        :value="identityType['value']"
                        :label="identityType['name']"
                      >
                      </BtnRadio>
                    </BtngroupRadio>
                  </InputGroup>
                </TableData>
              </TableRow>
            </TableBody>
          </TableBox>
          <TableBox class="-entry">
            <TableBody>
              <TableRow>
                <TableHeader> ご本人さま確認書類（2点目） </TableHeader>
                <TableData>
                  <div>
                    <InputGroup>
                      <BtngroupRadio class="_mb-5">
                        <BtnRadio
                          v-for="(
                            secondIdentityType, index
                          ) in secondIdentityTypes"
                          :id="'secondIdentityType' + index"
                          :key="'secondIdentityType' + index"
                          v-model="secondIdentity"
                          :class="{
                            disabled: isSelectedSecondIdentity(
                              secondIdentityType['value']
                            ),
                          }"
                          name="secondIdentityRadio"
                          :value="secondIdentityType['value']"
                          :label="secondIdentityType['name']"
                        >
                        </BtnRadio>
                      </BtngroupRadio>
                    </InputGroup>

                    <ListGroup class="-normal -note _ml-0">
                      <ListItem class="-note"
                        >公的書類は以下のいずれかに該当する書類をご提出ください。
                        <ListGroup class="-normal _ml-0">
                          <ListItem class="-normal"
                            >国税または地方税の領収書または納税証明書</ListItem
                          >
                          <ListItem class="-normal"
                            >社会保険料の領収書</ListItem
                          >
                          <ListItem class="-normal"
                            >公共料金の領収書（電気、都市ガス、水道、NHK、固定電話）</ListItem
                          >
                        </ListGroup>
                      </ListItem>
                    </ListGroup>
                  </div>
                </TableData>
              </TableRow>
            </TableBody>
          </TableBox>

          <slot name="message2"></slot>

          <TableBox class="-entry">
            <TableBody>
              <TableRow>
                <TableHeader>日本国籍をお持ちですか？ </TableHeader>
                <TableData>
                  <InputGroup>
                    <BtngroupRadio>
                      <BtnRadio
                        v-for="(nationalityType, index) in nationalityTypes"
                        :id="'nationalityType' + index"
                        :key="'nationalityType' + index"
                        v-model="nationality"
                        name="nationalityRadio"
                        :value="nationalityType['value']"
                        :label="nationalityType['name']"
                      >
                      </BtnRadio>
                    </BtngroupRadio>
                  </InputGroup>
                  <div v-show="showProofNationalityType(nationality)">
                    <p class="_mt-20 _mb-5">
                      以下のいずれかの書類が必要となりますので、選択してください。
                    </p>
                    <InputGroup>
                      <BtngroupRadio>
                        <BtnRadio
                          v-for="(
                            proofNationalityType, index
                          ) in proofNationalityTypes"
                          :id="'proofNationalityType' + index"
                          :key="'proofNationalityType' + index"
                          v-model="proofNationality"
                          name="proofNationalityRadio"
                          :value="proofNationalityType['value']"
                          :label="proofNationalityType['name']"
                        >
                        </BtnRadio>
                      </BtngroupRadio>
                    </InputGroup>
                  </div>
                </TableData>
              </TableRow>
            </TableBody>
            <!-- TableBody -->
          </TableBox>
        </TableGroup>
      </section>
      <BtngroupDouble class="-margin-lg">
        <template #main>
          <BtnMain class="-main upload" @click.prevent="goNext">
            <span class="-spnone">ファイルを選択する</span
            ><span class="-pcnone"
              >選択した書類を撮影して、<br />アップロードする</span
            >
          </BtnMain>
        </template>
        <template v-if="previousPageId" #back>
          <BtnBack
            class="-back -sm"
            router-name="en006"
            :query="{ state: '0' }"
          >
            戻る
          </BtnBack>
        </template>
      </BtngroupDouble>
    </form>
  </div>
</template>

<script>
import { goToErrorPage, scrollTop } from "@/utils/Other";
import {
  identityTypes,
  nationalityTypes,
  proofNationalityTypes,
  secondIdentityTypes,
} from "@/constants/constant";
import {
  fileUploadCreated,
  showProofNationalityType,
  validateEnIdentity,
  validateSecondIdentity,
  validateNationality,
  validateProofNationality,
} from "@/utils/FileUpload";

import HeadingOne from "@/components/heading/HeadingOne";
import ErrorsAlert from "@/components/alert/ErrorsAlert";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import InputGroup from "@/components/input/InputGroup";
import BtngroupRadio from "@/components/button/BtngroupRadio";
import BtnRadio from "@/components/button/BtnRadio";
import BtngroupDouble from "@/components/button/BtngroupDouble";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
export default {
  name: "IdentifyDblTop",
  components: {
    BtnBack,
    BtnMain,
    BtngroupDouble,
    BtnRadio,
    BtngroupRadio,
    InputGroup,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    ListItem,
    ListGroup,
    ErrorsAlert,
    HeadingOne,
  },
  props: {
    nextPageId: { type: String, default: "" },
    previousPageId: { type: String, default: "" },
    showBack: { type: String, default: "" },
  },
  setup() {
    return {
      fileUploadCreated,
      showProofNationalityType,
      validateEnIdentity,
      validateSecondIdentity,
      validateNationality,
      validateProofNationality,
    };
  },
  data() {
    return {
      errors: {},
      isDisabled: false,
      identityTypes: identityTypes,
      secondIdentityTypes: secondIdentityTypes,
      nationalityTypes: nationalityTypes,
      proofNationalityTypes: proofNationalityTypes,
      identity: this.$route.query.identity,
      secondIdentity: this.$route.query.secondIdentity,
      nationality: this.$route.query.nationality || "01",
      proofNationality: this.$route.query.proofNationality,
    };
  },
  created() {
    this.fileUploadCreated();
  },
  methods: {
    goNext: function () {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        this.validateEnIdentity(this.identity, this.errors);
        this.validateSecondIdentity(
          this.identity,
          this.secondIdentity,
          this.errors
        );
        this.validateNationality(this.nationality, this.errors);
        this.validateProofNationality(
          this.nationality,
          this.proofNationality,
          this.errors
        );
        if (Object.keys(this.errors).length > 0) {
          this.isDisabled = false;
          scrollTop();
          return;
        }
        let queryParam = {
          identity: this.identity || "00",
          secondIdentity: this.secondIdentity || "00",
          nationality: this.nationality || "02",
          proofNationality:
            this.nationality === "01" ? "00" : this.proofNationality || "00",
        };
        this.$router.push({ name: this.nextPageId, query: queryParam });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    isSelectedIdentity: function (val) {
      if (val === "01" || val === "02") {
        return this.secondIdentity === "01" || this.secondIdentity === "02";
      }
      return this.secondIdentity === val;
    },
    isSelectedSecondIdentity: function (val) {
      if (val === "01" || val === "02") {
        return this.identity === "01" || this.identity === "02";
      }
      return this.identity === val;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.btn-main.upload {
  @include mq-down(md) {
    display: block;
    font-size: 14px;
    padding-left: 25px;
    padding-right: 25px;
    border-radius: 32px;
    background-position: right 16px center;
  }
  @include mq-up(md) {
    border-radius: 42px;
  }
}
</style>
